<template>
  <BModal
    :model-value="modalIsShown"
    title="Join a company via an invitation"
    centered
    @hidden="close"
  >
    <div class="modal-body p-0">
      <div class="row">
        <div class="col-12">
          <p>You have an unconfirmed company invitation.</p>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="d-flex justify-content-end gap-2">
        <StoreButton @click="close">Skip for now</StoreButton>
        <StoreButton variant="primary" @click="goToCompanyInvite"
          >Show company invitation</StoreButton
        >
      </div>
    </template>
  </BModal>
</template>

<script lang="ts" setup>
import { BModal } from "bootstrap-vue-next";
import { useUiStore } from "~/stores/ui/uistore";
import StoreButton from "~/components/shared/buttons/StoreButton.vue";

function close() {
  uiStore.userCompanyInviteCode = undefined;
}
const uiStore = useUiStore();
const router = useRouter();
const route = useRoute();
const goToCompanyInvite = () => {
  router.push(`/invite?code=${uiStore.userCompanyInviteCode}`);
  close();
};

const modalIsShown = computed(() => {
  // do not show modal if user is on the company invite page already
  return (
    uiStore.userCompanyInviteCode !== undefined &&
    route.name !== "users-userid-company-registration-company-invite" &&
    route.name !== "users-userid-company-companyid-profile"
  );
});
</script>
<!-- scoped - does not work here because the bootstrap modal uses teleports -->
<style lang="scss"></style>
